import Header2 from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Footer2 from "./components/Footer/Footer2";
import { useMediaQuery } from 'react-responsive'


import './styles/App.css';
import Home from "./Pages/Home";
import Produits from "./Pages/Produits";
import Contacts from "./Pages/Contacts";
import Cart from "./Pages/Cart";
import Admin from "./Pages/Admin";
import NotFound from "./Pages/NotFound";
import ProduitDetail from "./components/ProduitDetail";
import ProduitCategorie from "./components/ProduitCategorie";


import 'react-toastify/dist/ReactToastify.css';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom'



function App() {
  const isBigScreen = useMediaQuery({ query: '(max-width: 920px)' })

  return (
    <div>
      <Router>
        <Header2 />
        <Routes>
           <Route exact path='/' element={<Home />} />
           <Route path='/produits' element={<Produits />} />
           <Route path='/produits/:id' element={<ProduitDetail />} />
           <Route path='/produit/:categorie' element={<ProduitCategorie />} />
           <Route path='/contacts' element={<Contacts />} />
           <Route path='/admin' element={<Admin />} />
           <Route path='/cart' element={<Cart />} />
           <Route path='/*' element={<NotFound />} />
        </Routes>
        {isBigScreen ? <Footer2 /> : <Footer />}
        
      </Router>
          
    </div>
  );
}

export default App;
